export enum ScheduleStatisticLevel {
  EMPLOYEE = 'EMPLOYEE',
  WEEK = 'WEEK',
  SHIFT = 'SHIFT'
}
